import { css } from '@linaria/core';

import { iconButtonBaseList } from '../constants';
import type { Size } from '../types';

const generateStyle = (size: Size) => `
	padding-right: calc(${iconButtonBaseList[size].paddingX} + var(--additional-padding-x));
	padding-left: calc(${iconButtonBaseList[size].paddingX} + var(--additional-padding-x));
	--button-icon-size: ${iconButtonBaseList[size].iconSize};
	--button-icon-padding: ${iconButtonBaseList[size].iconPadding};

	&.bigIcon {
		--button-icon-padding: ${iconButtonBaseList[size].bigIconPadding};
	}
`;

export const styledButton = css`
	&.sizeBadge {
		${generateStyle('Badge')}
	}

	&.sizeS {
		${generateStyle('S')}
	}

	&.sizeM {
		${generateStyle('M')}
	}

	&.sizeL {
		${generateStyle('L')}
	}
`;
